import apiClient from './client';

export const ActivitiesAllowedAxiosInstance = apiClient;